import { RecaptchaSettings } from 'ng-recaptcha';
import { ConfigurationModel } from '../services/api-client';

export function getApiBaseUrl(): string {
  if (/localhost:1337/.test(window.location.origin)) {
    return 'http://localhost:26739';
  }

  if (/myaccount\.planzer\.ch/.test(window.location.origin)) {
    return 'https://api.myaccount.app.planzer.ch';
  }

  return 'https://api.' + window.location.hostname;
}

export function getApiConfigUrl(): string {
  return `${getApiBaseUrl()}/config`;
}

export function getRecaptchaSettings(config: ConfigurationModel): RecaptchaSettings {
  return { siteKey: config.reCaptcha.siteKey };
}
